

export const PLACEHOLDER_IMAGE = 'assets/media/default.jpg';
export const PLACEHOLDER_IMAGE_WITH_PATH = './'+PLACEHOLDER_IMAGE;